module.exports = __webpack_public_path__ + "static/media/anker-soundcore-liberty-air-2.c7778211.jpg";